import React, { useMemo } from 'react';
import { Icon } from 'antd';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import useCompanies from '../../../../queries/useCompanies';
import useFilterState from '../../hooks/useFilterState';
import { filtersData } from '../../constants/filtersData';
import { filterNames } from '../../constants/filterNames';
import FilterDropdown from '../FilterDropdown/FilterDropdown';
import useFilterItemsWithAmount from '../../hooks/useFilterItemsWithAmount';
import styles from './CompaniesDropdown.module.scss';
import { ReactComponent as DropdownIcon } from '../../../../resource/statistics/ukDropdown.svg';

const companiesFilter = filtersData[filterNames.companies];

const CompaniesDropdown = () => {
  const [companiesFilterState] = useFilterState(companiesFilter);

  const { data, isFetching: isCompaniesFetching } = useCompanies({
    staleTime: Infinity,
  });

  const { items: companies, itemsMap: companiesMap } = useFilterItemsWithAmount(
    {
      data,
      requestKey: 'companyId',
    }
  );

  const text = useMemo(() => {
    if (isCompaniesFetching) {
      return 'Загрузка...';
    } else {
      if (companiesFilterState.length === 0) {
        return 'Выбрать УК';
      }

      if (companiesFilterState.length === 1) {
        const [companyId] = companiesFilterState;

        const text =
          companiesMap.size > 0
            ? companiesMap.get(companyId)?.name || 'Нет данных'
            : 'Не указано';

        return text;
      }

      return 'Несколько УК';
    }
  }, [isCompaniesFetching, companiesFilterState, companiesMap]);

  return (
    <FilterDropdown
      disabled={isCompaniesFetching}
      filter={companiesFilter}
      items={companies}
      getItemContent={(company) => company.name}
      getSearchContent={(company) => company.name}
      renderButton={() => (
        <RoundedButton
          className={styles.menuClassName}
          type="secondary"
          text={
            <span>
              <Icon
                component={DropdownIcon}
                className={styles.icon}
              />
              {text}
            </span>
          }
          iconRight={<Icon type="caret-down" />}
        />
      )}
    />
  );
};

export default CompaniesDropdown;
